import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout = ({
  children
}: LayoutProps) => {
  return <div className="flex flex-col min-h-screen bg-background text-text-main transition-colors duration-300" data-id="element-139">
      <Header data-id="element-140" />
      <main className="flex-grow" data-id="element-141">{children}</main>
      <Footer data-id="element-142" />
    </div>;
};